<template>
  <article v-on:click="this.$emit('perform', 'goToContent', this.content);"> 
    <div class="wrapper" :style="spiritColor">
      <div class="title">{{ content.attributes.title }}</div>
    </div>
  </article>
</template>

<script>
  import ContentMixin from "@/components/ContentMixin.vue";
  import { router} from "../../../common";
  export default {
    name: "Album",
    props: {
      content: Object,
      channel: Object,
      rally: Object
    },
    mixins: [
      ContentMixin
    ],
    computed: {
      spiritColor() {
        const colors = ["#40B5BC", "#5AC6C6", "#8FD0CA", "#03DACE", "#42ABC5"];
        const spiritNumber = Math.floor(parseInt(this.content.id.split("").pop()) / 2);
        return `background-color: ${colors[spiritNumber]};`;
      },
    },
    methods: {

     /* goToContent() {
        const currentPath = this.$route.path;
          if (currentPath.indexOf("/c/") < 0){
            router.push(`${currentPath}/c/${this.content.id}`);
          } else {
            router.push(`${currentPath}/${this.content.id}`);
          }
          this.$emit('perform', 'openContainer', this.content);
        }*/
    }
  };
</script>
